import styled from 'styled-components'

import { HEADER_HEIGHT } from '../Header/styled'
import {
  BOTTOM_NAV_HEIGHT_DESKTOP,
  BOTTOM_NAV_HEIGHT_MOBILE,
} from '../BottomNavigation/styled'

import { media } from 'src/styles/media'

export const ContentWrap = styled.div`
  overflow: auto;
  height: calc(100% - ${BOTTOM_NAV_HEIGHT_MOBILE}rem);

  ${media.desktop} {
    height: calc(100% - ${HEADER_HEIGHT}rem - ${BOTTOM_NAV_HEIGHT_DESKTOP}rem);
  }
`
